import * as R from 'ramda'

export const setIn = R.curry((path: string | Array<string | number>, payload: any, existingState: object) => {
  const lens =
    typeof path === 'string'
      ? R.lensProp<any>(path as any) // cast to any to avoid 'never'
      : R.lensPath(path as Array<string | number>)
  return R.set(lens, payload, existingState)
})

type Path = string | number | Array<string | number>

const viewer = (path: Path) => (propsToRead: any) => {
  if (typeof path === 'string' || typeof path === 'number') {
    return R.view(R.lensProp(path), propsToRead)
  }
  return R.view(R.lensPath(path), propsToRead)
}

/**
 * Access an object/array through array notation. Similar to lodash.get.
 *
 * @usage getIn(['communicationRestrictions', 'doNotCall'], contact)
 * @usage getIn(['communicationRestrictions', 'doNotCall'])(contact)
 * @note  `getIn` is around the place (mostly used for data from the API) to
 *        assure that old cached data doesn't break.
 */
export const getIn: {
  (path: Path, propsToRead: any): any
  (path: Path): (propsToRead: any) => any
} = R.curry((path: Path, propsToRead: any) => viewer(path)(propsToRead))

export const hasIn = R.curry((path: Path, propsToRead: any): boolean => Boolean(viewer(path)(propsToRead)))
